/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { TransmittalRecordInputDto } from './transmittalRecordInputDto.schema';

export const ReceiveTransmittalRecord = zod.object({
  "id": zod.string().uuid().optional(),
  "payload": zod.lazy(() => TransmittalRecordInputDto).optional()
});

export type ReceiveTransmittalRecord = zod.input<typeof ReceiveTransmittalRecord>;
export type ReceiveTransmittalRecordOutput = zod.output<typeof ReceiveTransmittalRecord>;
